import { render, staticRenderFns } from "./intro_page.vue?vue&type=template&id=410feb13&scoped=true"
import script from "./intro_page.vue?vue&type=script&lang=js"
export * from "./intro_page.vue?vue&type=script&lang=js"
import style0 from "./intro_page.vue?vue&type=style&index=0&id=410feb13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410feb13",
  null
  
)

export default component.exports